import { AxiosError } from 'axios';
import { useMutation, UseMutationResult } from 'react-query';
import { api } from '../api';
import queryClient from '../query-client';

type UnlinkTaxPayerRequest = { entityId: string; mappingId: string };

async function unlinkTaxpayers(params: UnlinkTaxPayerRequest): Promise<void> {
    await api.delete(`/entities/${params.entityId}/integrations/atosa/${params.mappingId}`);
}

export function useUnlinkAtosaTaxpayer(): UseMutationResult<void, AxiosError, UnlinkTaxPayerRequest, unknown> {
    return useMutation(unlinkTaxpayers, {
        onSettled: () => {
            queryClient.invalidateQueries(['atosa']);
            queryClient.invalidateQueries(['entities']);
        },
    });
}
